import React, { useEffect, useMemo, useState } from "react";
import { GrAscend, GrDescend } from "react-icons/gr";
import { PiMagnifyingGlass } from "react-icons/pi";
import { TbReload, TbTrash } from "react-icons/tb";
import SidebarModelsLoading from "../Loaders/SidebarModelsLoading";
import MandatorySign from "../Components/MandatorySign";
import { Dropdown } from "react-bootstrap";
import { BiPlus } from "react-icons/bi";
import Spinner from "../Components/Spinner";
import LoaderInstructions from "../Loaders/LoaderInstructions";
import { LuTrash2 } from "react-icons/lu";
import DeleteItemModal from "../Components/DeleteItemModal";
import { useLanguage } from "../Translations/LenguageContext";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const SystemInstructionsSidebar = ({
    account_id,
    show,
    handleClose,
    selectedSystemInstructionsId,
    setSelectedSystemInstructionsId,
    setSelectedSystemInstructions
}) => {
    const {t} = useLanguage()
    const [data, setData] = useState([]);
    const [loadingData, setLoadingData] = useState(false);
    const [loadingDataSave, setLoadingDataSave] = useState(false)
    const [searchTerm, setSearchTerm] = useState("");
    const [sortOrder, setSortOrder] = useState("asc");
    const [systemInstructions, setSystemInstructions] = useState([])
    const [systemInstId, setSystemInstId] = useState(null)
    const [openDeleteItem, setOpenDeleteItem] = useState(false)
    const [selectedItem, setSelectedItem] = useState({})

    const [formData, setFormData] = useState({
        title: "",
        instruction: ""
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const fetchInstructions = async () => {
        setLoadingData(true)
        try {
            const response = await fetch(`${GEN_BACKEND_LINK}/get_instructions`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    account_id
                }),
            });

            const result = await response.json();

            if (!response.ok) {
                throw new Error(result.error || "Failed to fetch");
            }
            setSystemInstructions(result.data)
        } catch (err) {
            console.error("Error fetching models:", err);
            setLoadingData(false)
        } finally {
            setTimeout(() => {
                setLoadingData(false)
            }, 500);
        }
    };

    const saveNewInstruction = async () => {
        setLoadingDataSave(true)
        try {
            const response = await fetch(`${GEN_BACKEND_LINK}/save_new_instruction`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    account_id,
                    inst_id: systemInstId,
                    title: formData.title,
                    instruction: formData.instruction
                }),
            });

            const result = await response.json();

            if (!response.ok) {
                throw new Error(result.error || "Failed to fetch");
            }

            setSystemInstId(result.id)
            fetchInstructions()
        } catch (err) {
            console.error("Error fetching models:", err);
            setLoadingDataSave(false)
        } finally {
            setTimeout(() => {
                setLoadingDataSave(false)
            }, 500);
        }
    };

    const setSelectItem = (item) => {
        setFormData({
            title: item.title,
            instruction: item.instruction
        })
        setSystemInstId(item.id)
        setSelectedSystemInstructionsId(item.id)
        setSelectedSystemInstructions(item)
    }

    const handleDeleteInstruction = (item) => {
        setSelectedItem(item)
        setNewInstruction()
        setOpenDeleteItem(true)
    }

    const setNewInstruction = () => {
        setFormData({
            title: "",
            instruction: ""
        })
        setSystemInstId(null)
        setSelectedSystemInstructionsId(null)
        setSelectedSystemInstructions(null)
    }

    const closeSidebar = () => {
        handleClose()
    }

    useEffect(() => {
        fetchInstructions()
    }, [show])

    useEffect(() => {
        if (!selectedSystemInstructionsId) return;

        const selected = systemInstructions.find(
            (item) => item.id === selectedSystemInstructionsId
        );

        if (selected) {
            setFormData({
                title: selected.title,
                instruction: selected.instruction
            });
            setSystemInstId(selected.id);
            setSelectedSystemInstructions(selected)
        }
    }, [loadingData]);

    return (
        <div className={`sidebar_right_cont ${show ? "sidebar_right_cont_show" : ""}`}>
            <div className="sidebar_right_close" onClick={closeSidebar}></div>
            <div className="sidebar_right_main">
                <div className="sidebar_right_main_header">
                    <p>{t.playground.sys_inst_title}</p>
                    <button onClick={closeSidebar}><i className="fa-solid fa-x"></i></button>
                </div>

                {loadingData ? (
                    <LoaderInstructions />
                ) : (
                    <div className="sidebar_right_main_body_instructions">
                        <div className="label_input">
                            <Dropdown>
                                <Dropdown.Toggle
                                    as="div"
                                    className="register_form_first fade-in"
                                >
                                    {formData.title ? (
                                        formData.title
                                    ) : (
                                        "Select instruction"
                                    )}
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="custom_dropdown_menu">

                                    <div className="dropdown_container fade-in">
                                        <button
                                            onClick={setNewInstruction}
                                            className="settings_link"
                                        >
                                            <BiPlus /> {t.playground.new_intruction}
                                        </button>
                                        {systemInstructions.length > 0 && (
                                            systemInstructions.map((item) => (
                                                <div
                                                    onClick={() => setSelectItem(item)}
                                                    className={`settings_link settings_link_space_between ${systemInstId == item.id && "settings_link_selected"}`}
                                                >
                                                    {item.title}
                                                    <button
                                                        className="remove_file_btn"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            handleDeleteInstruction(item)
                                                        }}
                                                        title="Delete"
                                                    >
                                                        <LuTrash2 />
                                                    </button>
                                                </div>
                                            ))
                                        )}
                                    </div>
                                </Dropdown.Menu>
                            </Dropdown>
                        </div>
                        <label className="input_label">{t.title} <MandatorySign message={t.mandatory_field} /></label>
                        <input
                            type="text"
                            name="title"
                            value={formData.title}
                            onChange={handleChange}
                            placeholder="Ex. Instructions"
                            className="register_form_first fade-in"
                        />
                        <label className="input_label">{t.playground.instructions} <MandatorySign message={t.mandatory_field} /></label>
                        <textarea
                            name="instruction"
                            value={formData.instruction}
                            onChange={handleChange}
                            placeholder="Give the tone and style for the model..."
                            className="register_form_first textarea_reg fade-in textarea_reg_instruction"
                        />
                        <div className="save_instruction_btn_cont">
                            <button onClick={setNewInstruction} className="save_instruction_btn"><TbReload /> {t.playground.reset}</button>

                            <button onClick={saveNewInstruction} className="save_instruction_btn" disabled={loadingDataSave}>
                                {loadingDataSave ? (
                                    <Spinner loading={true} />
                                ) : (
                                    t.save
                                )}
                            </button>
                        </div>
                    </div>
                )}
            </div>

            <DeleteItemModal
                account_id={account_id}
                show={openDeleteItem}
                handleClose={() => setOpenDeleteItem(false)}
                fetchRecords={fetchInstructions}
                item={selectedItem}
                endpoint={"delete_instruction"}
                title={t.playground.delete_instruction_title}
                description={t.playground.delete_instruction_warning}
                input_value={selectedItem}
            />
        </div>
    );
}

export default SystemInstructionsSidebar;